import { render, staticRenderFns } from "./BulkContractServiceFeeEditor.yaml?vue&type=template&id=1fbd7902&component"
import script from "./BulkContractServiceFeeEditor.yaml?vue&type=script&lang=ts&component"
export * from "./BulkContractServiceFeeEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports